import Navbar from './Navbar'
import SidebarRouter from './SidebarRouter'
import NavPage from './NavPage'
import MainpageStyles from "../styles/Mainpage.module.css"
import React, {useState, useEffect} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import AppProvider from '../context/AppProvider';
import { useAuth0 } from '@auth0/auth0-react';
import { Backdrop, CircularProgress, Box, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { getResponsiveNavPageStyle } from '../utils/sidebarUtils';


function MainPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, isLoading } = useAuth0();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [selectedLayers] = useState([]);
    const [selectedPurpose] = useState("");
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
    const [accountSwitching, setAccountSwitching] = useState(() => {
        return sessionStorage.getItem('accountSwitching') === 'true';
    });

    const [, setInitialLayers] = useState([]);
    const isPublicRoute = location.pathname.startsWith('/request-otp') || location.pathname.startsWith('/unsubscribe');

    // Clear switching overlay after component mounts and Auth0 is loaded
    useEffect(() => {
        if (accountSwitching && !isLoading) {
            const timer = setTimeout(() => {
                sessionStorage.removeItem('accountSwitching');
                setAccountSwitching(false);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [accountSwitching, isLoading]);

    // Debug: Log current route
    useEffect(() => {
    }, [location.pathname]);

    // Handle Auth0 redirect (organization signup intent)
    useEffect(() => {
        const redirectTo = sessionStorage.getItem('auth0RedirectTo');


        // Check if we're on /home after potential Auth0 redirect
        if (location.pathname === '/home' && !isLoading && isAuthenticated && !redirectTo) {
        }

        // Only navigate after Auth0 has finished loading
        if (redirectTo && !isLoading) {

            if (isAuthenticated) {
                sessionStorage.removeItem('auth0RedirectTo'); // Clear flag
                navigate(redirectTo, { replace: true });
            } else {
            }
        }
    }, [navigate, isAuthenticated, isLoading, location.pathname]);

    // receiving initial layers from NavPage
    const triggerMapLoadLayers = (initialLayers) => {
        //console.log("MainPage initial map load layers:" + initialLayers);
        setInitialLayers(initialLayers);
    };

    useEffect(() => {
        const handleReload = () => {
            const currentPath = window.location.pathname;
            //console.log('Current Path:', currentPath);
            if (currentPath === '/Resources') {
                //console.log('Reloaded on homepage');
            }
        };

        window.addEventListener('beforeunload', handleReload);

        return () => {
            window.removeEventListener('beforeunload', handleReload);
        };
    }, []);


    return (
        <React.Fragment>
            {/* Account Switching Overlay */}
            <Backdrop
                open={accountSwitching}
                sx={{
                    color: '#fff',
                    zIndex: 99999,
                    backgroundColor: 'rgba(0, 0, 0, 0.9)'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2
                    }}
                >
                    <CircularProgress color="inherit" size={60} />
                    <Box sx={{ textAlign: 'center' }}>
                        <p style={{ fontSize: '18px', fontWeight: 500, margin: '8px 0' }}>
                            Switching Account...
                        </p>
                        <p style={{ fontSize: '14px', opacity: 0.9, margin: 0 }}>
                            Please wait while we load your data
                        </p>
                    </Box>
                </Box>
            </Backdrop>

            <AppProvider>
                {/* heading section */}
                {/* <section>
          <div>
              <Navbar/>
          </div>
        </section> */}


                {/* heading section */}
                <section className={MainpageStyles.fullscreen}>
                    {!isPublicRoute && (
                        <div className={MainpageStyles.Navbartop}>
                            <Navbar onMenuClick={() => setMobileDrawerOpen(!mobileDrawerOpen)} />
                        </div>
                    )}

                    <div className={MainpageStyles.Sidebar}>
                        {/* Desktop Sidebar */}
                        {!isPublicRoute && !isMobile && (
                            <div className={MainpageStyles.SidebarItems}>
                                <SidebarRouter
                                    collapsed={sidebarCollapsed}
                                    onCollapsedChange={setSidebarCollapsed}
                                />
                            </div>
                        )}

                        {/* Mobile Drawer */}
                        {!isPublicRoute && isMobile && (
                            <Drawer
                                anchor="left"
                                open={mobileDrawerOpen}
                                onClose={() => setMobileDrawerOpen(false)}
                                ModalProps={{
                                    keepMounted: true, // Better open performance on mobile
                                }}
                                sx={{
                                    '& .MuiDrawer-paper': {
                                        width: 256,
                                        boxSizing: 'border-box',
                                        top: '56px', // Position below navbar (navbar height)
                                        height: 'calc(100% - 56px)', // Adjust height to account for navbar
                                    },
                                }}
                            >
                                <SidebarRouter
                                    collapsed={false}
                                    onCollapsedChange={setSidebarCollapsed}
                                    onNavigate={() => setMobileDrawerOpen(false)}
                                    isInDrawer={true}
                                />
                            </Drawer>
                        )}

                        <div className={
                            isPublicRoute
                                ? `${MainpageStyles.Navpage} ${MainpageStyles.publicNavpage}`
                                : MainpageStyles.Navpage
                        }
                        style={getResponsiveNavPageStyle(sidebarCollapsed, isPublicRoute)}>
                            <NavPage parentSelectedLayers={selectedLayers} selectedPurpose={selectedPurpose}
                                     sendParentMapLoadLayers={triggerMapLoadLayers}/>
                        </div>
                    </div>
                </section>
            </AppProvider>


        </React.Fragment>

    );
}

export default MainPage;